var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightLong = function SvgArrowRightLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 86 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.706 7.198a1 1 0 0 1 .003 1.414l-6.35 6.378a1 1 0 0 1-1.417-1.411l5.644-5.67-5.67-5.644A1 1 0 1 1 79.327.848l6.379 6.35Zm-.704 1.708-84 .188-.004-2 84-.188.004 2Z",
    fill: "#42210A"
  })));
};
export default SvgArrowRightLong;